export enum routes {
  HOME = "/",
}
